import { Auth } from '@opoint/authjs'
import Cookies from 'js-cookie'

export const TOKEN_KEY = 'token'

export const authModule = {
  namespaced: true,
  state: () => ({
    auth: null
  }),
  mutations: {
    logOut(state) {
      state.auth.logout()
      Cookies.remove('token')
    }
  },
  actions: {
    /**
     * Initializes auth store. Only reject promise if invalid token (because not being
     * logged in is a completely valid state for the auth store)
     *
     * @param commit
     * @param state
     * @param token
     * @returns {Promise<unknown>}
     */
    async init({ state }) {
      console.debug("auth store init")
      state.auth = new Auth('https://auth.opoint.com', 'https://ohm.opoint.com', true, true)
      await state.auth.getState() // This ensures the autologin triggers right away
    }
  },
  getters: {
    isLoggedIn(state) {
      return !!(state.auth && state.auth.state) 
    },
  }
}
